export default [
    {
        comment: 'use . instead of : at the end of the sentence',
        error_id: 'T-IEFF-01',
        data: [
            {
                "cross_section": "43827",
                "data": [
                    {
                        "cross_section": "43827",
                        "base_start_sta": null,
                        "base_end_sta": null,
                        "base_elev": null,
                        "base_perm": null,
                        "cmp_start_sta": 0,
                        "cmp_end_sta": 624.1,
                        "cmp_elev": 159.23,
                        "cmp_perm": null
                    },
                    {
                        "cross_section": "43827",
                        "base_start_sta": null,
                        "base_end_sta": null,
                        "base_elev": null,
                        "base_perm": null,
                        "cmp_start_sta": 653.13,
                        "cmp_end_sta": 0,
                        "cmp_elev": 158.46,
                        "cmp_perm": null
                    },
                    {
                        "cross_section": "43827",
                        "base_start_sta": null,
                        "base_end_sta": null,
                        "base_elev": null,
                        "base_perm": null,
                        "cmp_start_sta": 675.54,
                        "cmp_end_sta": 678.05,
                        "cmp_elev": 158.04,
                        "cmp_perm": null
                    }
                ]
            }
        ]
    }
]